

export const primaryButtonStyle =
  "mt-3 md:mt-0 lg:mt-0 w-full md:w-auto lg:w-auto  md:ml-3 disabled:opacity-50 rounded-lg py-3  px-5 bg-blue-400 text-white  hover:bg-blue-600 hover:text-white transition ease-in-out duration-300 text-sm whitespace-nowrap";

export const secondaryButtonStyle =
  "mt-3 md:mt-0 lg:mt-0 w-full md:w-auto sm:w-full md:ml-3 disabled:opacity-50 rounded-lg py-3  px-5 bg-gray-400 text-white  hover:bg-gray-500 hover:text-white transition ease-in-out duration-300 text-sm";

export const warningButtonStyle =
  "ml-3 rounded-lg py-1  px-5 bg-red-500 text-black hover:bg-red-800 hover:text-white transition ease-in-out duration-300 text-sm";

export const deleteButton =
  "ml-3 rounded-lg py-0 px-3 bg-gray-700 text-black hover:bg-red-800 hover:text-white text-sm";

export const blurBackground =
  "backdrop-blur flex-none transition-colors duration-500 lg:z-50 bg-black supports-backdrop-blur:bg-green/10 dark:bg-transparent";

export const greenButtonStyle =
  " disabled:opacity-50 rounded-lg py-3  px-5 bg-green-600 text-white  hover:bg-green-800 hover:text-white transition ease-in-out duration-300 text-sm whitespace-nowrap";

export const blurBackgroundEAT =
  "background: #000 backdrop-blur flex-none transition-colors duration-500 lg:z-50 bg-black supports-backdrop-blur:bg-green/40";
